module.exports = __webpack_public_path__ + "static/media/industries-stone-s.b1911ce3.jpg";